import Script from 'next/script';
import { useEffect } from 'react';

import { useCurrentUser } from '@/modules/authentication/hooks/useCurrentUser';

const PYLON_APP_ID = 'e0ead070-255d-48cb-9ca3-e295a81ce40e';

/**
 * Pylon Chat integration component.
 * Loads the Pylon chat widget script and initializes it with the current user's information.
 * The widget is loaded asynchronously after the page becomes interactive.
 * When a user is logged in, their email and display name are passed to the chat widget
 * to provide context for support conversations.
 */

export function PylonChat() {
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (currentUser) {
      window.pylon = {
        chat_settings: {
          app_id: PYLON_APP_ID,
          email: currentUser.email,
          name: currentUser.displayName,
        },
      };
    }
  }, [currentUser]);

  // NOTE NOTE NOTE
  // This script is allowed to run because of a hash of it present in the CSP.
  // If you change the script content, you'll need to update the CSP hash.
  return (
    <Script
      id="pylon-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function(){
            var e=window;
            var t=document;
            var n=function(){n.e(arguments)};
            n.q=[];
            n.e=function(e){n.q.push(e)};
            e.Pylon=n;
            var r=function(){
              var e=t.createElement("script");
              e.setAttribute("type","text/javascript");
              e.setAttribute("async","true");
              e.setAttribute("src","https://widget.usepylon.com/widget/${PYLON_APP_ID}");
              var n=t.getElementsByTagName("script")[0];
              n.parentNode.insertBefore(e,n)
            };
            if(t.readyState==="complete"){
              r()
            } else if(e.addEventListener){
              e.addEventListener("load",r,false)
            }
          })();
        `,
      }}
    />
  );
}
